import * as server from '../entries/pages/(admin)/admin/_layout.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(admin)/admin/_layout.svelte.js')).default;
export { server };
export const server_id = "src/routes/(admin)/admin/+layout.server.ts";
export const imports = ["_app/immutable/nodes/2.DFqwz6kO.js","_app/immutable/chunks/yI7QhVT-.js","_app/immutable/chunks/DdBbTIYF.js","_app/immutable/chunks/B7lD3_W4.js","_app/immutable/chunks/BT_zozEV.js","_app/immutable/chunks/hhdU8v22.js","_app/immutable/chunks/DxFD9Sm-.js","_app/immutable/chunks/WaQmNrQ1.js","_app/immutable/chunks/BSTIXOHC.js","_app/immutable/chunks/CQVtHfxE.js","_app/immutable/chunks/CTRjNHmM.js","_app/immutable/chunks/DMZiD_i_.js"];
export const stylesheets = ["_app/immutable/assets/2.jJCZVnCa.css"];
export const fonts = [];
